import { useQuery } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'
import { getTypeOfMonths, getAllTypeOfMonths } from '../../../../api/agencyAdmin/bonus';
import { useDebouncedState, useWindowScroll } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';

function useGetTypeOfMonth() {

    const [scroll, scrollTo] = useWindowScroll();
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useDebouncedState('', 500);
    const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const TypeOfMonthQuery = useQuery({
        queryFn: () => getTypeOfMonths({
            search,
            page: page,
            per_page: perPage,

        }),
        queryKey: ["TypeOfMonth_list", perPage, page, search],

        placeholderData: (previousData, previousQuery) => previousData, // identity function with the same behaviour as `keepPreviousData`,


    });

    const { isPending, isFetching, data } = TypeOfMonthQuery
    useEffect(() => {
        if (!isPending && !isFetching) {
            notifications.clean()
        }
        // if (!isPending && isFetching) {
        //     loadingNotification({})
        // }
        if (data) {
            setTotalRows(data?.meta?.total)
        }

    }, [isPending, isFetching]);




    const handlePageChange = async (newPerPage) => {

        setPage(newPerPage);


    };


    const handleChangePerPage = (perPage, page) => {
        setPerPage(perPage);
        setPage(page)

    }


    const TypeOfMonthListQuery = useQuery({
        queryKey: ["load data get match style query"],
        queryFn: () => getAllTypeOfMonths({
        }),
        select: (res) => {
            if (res
            ) {
                console.log(res);

                return res
                    .map((item) => ({
                        label: item.name,
                        value: item.name,
                    }))

            } else {
                return []
            }
        }

    });


    return {
        TypeOfMonthQuery,
        TypeOfMonthListQuery,
        totalRows,
        handlePageChange,
        search,
        setSearch,
        handleChangePerPage,
        queryKey: ["TypeOfMonth_list", perPage, page, search],
    }
}

export default useGetTypeOfMonth
